import styled from 'styled-components';

const Container = styled.div`
	max-width: 1280px;
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 1023px) {
		padding-left: 25px;
		padding-right: 25px;
	}

	@media (max-width: 767px) {
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export default Container;
